import { useState } from "react";

export const useKlaviyoSubscribe = (endpoint, listId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const subscribe = async (email) => {
    if (!email) {
      setError("Please enter a valid email address.");
      return;
    }

    setIsLoading(true);
    setError(null);
    setSuccess(false);

      const subscribeData = {
        data: {
          "type": "subscription",
          "attributes": {
            "profile": {
              "data": {
                "type": "profile",
                  "attributes": {
                  "email": `${email}`
                }
              }
            },

          },
           "relationships": {
              "list": {
                "data": {
                  "type": "list",
                  "id": `${listId}`
                }
              }
            }
        }
    };

    console.log("Klaviyo Submit", email);

    try {
      const response = await fetch(
        endpoint,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "revision": "2024-07-15"
          },
          body: JSON.stringify(subscribeData),
        },
      );

      console.log('Response', response);

      if (response.ok) {
        setSuccess(true);
        setError(null);
      } else {
        setSuccess(false);
        setError("Failed to subscribe. Please try again.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    success,
    subscribe,
  };
};
